import React from "react";
import { IItem } from "@/redux/profile/history/types";
import HistoryItem from "@/pages/Profile/components/HistoryItem";
import styles from "./HistoryDateSection.module.scss";

interface HistoryDateSectionProps {
  date: string;
  items: IItem[];
}

export const HistoryDateSection: React.FC<HistoryDateSectionProps> = ({ date, items }) => {
  return (
    <div className={styles.dateSection}>
      <h3 className={styles.dateTitle}>
        {date}
      </h3>
      <div className={styles.item}>
        {items.map((item, index) => (
          <HistoryItem key={`${date}-${index}`} data={item} />
        ))}
      </div>
    </div>
  );
};
